import React, { useEffect, useState } from 'react';
import './Ads.css';

function Ads({ type, countryid }) {

    const listingads = [
        {
            image: "https://soukakarat.com/controller/ads/propertydynamicslisting.png",
            title: "",
            subtitle: "",
            link: "https://www.propertydynamics.soukakarat.com"
        },
        {
            image: "https://soukakarat.com/controller/ads/soukakaratlisting.png",
            title: "",
            subtitle: "",
            link: "https://www.soukakarat.com"
        },
        {
            image: "https://soukakarat.com/controller/ads/accountingdynamicslisting.png",
            title: "",
            subtitle: "",
            link: "https://www.accountingdynamics.soukakarat.com"
        },
    ];

    const listingsads = [
        {
            image: "https://soukakarat.com/controller/ads/propertydynamicslistings.png",
            title: "",
            subtitle: "",
            link: "https://www.propertydynamics.soukakarat.com"
        },
        {
            image: "https://soukakarat.com/controller/ads/soukakaratlistings.png",
            title: "",
            subtitle: "",
            link: "https://www.soukakarat.com"
        },
        {
            image: "https://soukakarat.com/controller/ads/accountingdynamicslistings.png",
            title: "",
            subtitle: "",
            link: "https://www.accountingdynamics.soukakarat.com"
        },
    ];

    const ads = type === "listing" ? listingads : listingsads;

    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex(prev => (prev + 1) % ads.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [ads.length]);

    const ad = ads[index];

    if (type === 'listing') return (
        <a href={ad.link} className="ads_listing" style={{ backgroundImage: `url(${ad.image})` }}>
            <div className="ads_listingcontent">
                <div className="ads_listingtitlecontainer">
                    <div className="ads_listingtitle">{ad.title}</div>
                    <div className="ads_listingsubtitle">{ad.subtitle}</div>
                </div>
            </div>
        </a>
    );

    if (type === 'listings') return (
        <a href={ad.link} className="ads_listings" style={{ backgroundImage: `url(${ad.image})` }}> </a>
    );

    return null;
}

export default Ads;